import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';


class Topbar extends Component {
    render() {
        return (
         <div>
            <Navbar color="white" light fixed="top" >
              <NavbarBrand href="https://www.provestor.co.uk/?utm_source=calculator&utm_medium=referral">
                <img src='/img/pv-logo-green.svg' alt="Provestor logo" />
              </NavbarBrand>
               <Nav className="ml-auto" navbar>
                  <span className="navbar-text">
                  {this.props.title}
                  </span>
              </Nav>
            </Navbar>
          </div>
        );
      }
}

export default Topbar;



// WEBPACK FOOTER //
// ./src/components/Layout/Topbar.jsx